import { render, staticRenderFns } from "./AppointmentPartnerCompany.vue?vue&type=template&id=45b46b5c"
import script from "./AppointmentPartnerCompany.vue?vue&type=script&lang=ts"
export * from "./AppointmentPartnerCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports